import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Form } from "antd";
import DrawerForm from "components/form";
import { bindActionCreators, Dispatch } from "redux";
import { Creators as LobbyActions } from "store/lobby/lobby-duck";
import { IRegisterActiveItem, IProcessesData, IDocumentsData, ISaleChannelData, IDocumentType, PlateFormatType } from "store/lobby/lobby-model";
import { Creators as VehicleDashboardActions } from "store/vehicle-dashboard/vehicle-dashboard-duck";
import { DrawerStatusEnum } from "typings/global.types";
import { mountRegisterFormValues } from "utils/form/saleChannel";

interface IPropsScreenViewRegister {
  form?: any;
  inboundProcessesList: IProcessesData[];
  salesChannelList?: ISaleChannelData[];
  documentsList?: IDocumentsData[];
  registerActive?: IRegisterActiveItem;
  hasSaleChannel: boolean;
  visibleDrawerViewRegisterVehicleDashboard: boolean;
  drawerIsLoading: boolean;
  visibleDrawerViewMode?: DrawerStatusEnum;
  documentType?: IDocumentType;
  plateFormatType?: PlateFormatType;
}

interface IDispatchProps {
  lobbyDocumentsFetchAsync?: (...args) => void;
  lobbyProcessActive: (...args) => void;
  lobbySaleChannelActive: (...args) => void;
}

export type IViewRegister = IPropsScreenViewRegister & IDispatchProps;

const ViewRegister = ({
  form,
  documentsList,
  hasSaleChannel,
  registerActive,
  drawerIsLoading,
  salesChannelList,
  documentType,
  inboundProcessesList,
  visibleDrawerViewMode,
  plateFormatType,
  visibleDrawerViewRegisterVehicleDashboard,
  lobbyDocumentsFetchAsync,
  lobbySaleChannelActive,
  lobbyProcessActive,
}: IViewRegister) => {
  useEffect(() => {
    if (registerActive?.id) {
      form.setFieldsValue(mountRegisterFormValues(registerActive, hasSaleChannel, salesChannelList));
    }
  }, [registerActive, hasSaleChannel, salesChannelList]);

  return (
    <Form.Provider>
      <DrawerForm
        form={form}
        disabledFields={true}
        documentsList={documentsList}
        lobbyDocumentsFetchAsync={lobbyDocumentsFetchAsync}
        registerActive={registerActive}
        carrierRef={null}
        lobbyProcessActive={lobbyProcessActive}
        inboundProcessesList={inboundProcessesList}
        hasSaleChannel={hasSaleChannel}
        lobbySaleChannelActive={lobbySaleChannelActive}
        salesChannelList={salesChannelList}
        visibleDrawerView={visibleDrawerViewRegisterVehicleDashboard}
        visibleDrawerAddNewRegister={false}
        visibleDrawerViewMode={visibleDrawerViewMode}
        drawerIsLoading={drawerIsLoading}
        documentType={documentType}
        hasEntryPermission={false}
        plateFormatType={plateFormatType}
      />
    </Form.Provider>
  );
};

const mapDispatchToActions = (dispatch: Dispatch) => bindActionCreators({ ...LobbyActions, ...VehicleDashboardActions }, dispatch);

const mapStateToProps = (state) => ({
  documentsList: state.Lobby.documentsList,
  hasSaleChannel: state.Lobby.hasSaleChannel,
  registerActive: state.Lobby.registerActive,
  drawerIsLoading: state.Lobby.drawerIsLoading,
  salesChannelList: state.Lobby.salesChannelList,
  inboundProcessesList: state.Lobby.inboundProcessesList,
  visibleDrawerViewMode: state.Lobby.visibleDrawerViewMode,
  documentType: state.Lobby.documentType,
  plateFormatType: state.Lobby.plateFormatType,
  visibleDrawerViewRegisterVehicleDashboard: state.VehicleDashboard.visibleDrawerViewRegisterVehicleDashboard,
});

export default connect(mapStateToProps, mapDispatchToActions)(ViewRegister);
